export const ActionTypes = {
  SET_CURRENTUSERS: "settingCurrentUser",
};

export const setCurrentUser = (user) => ({
  type: ActionTypes.SET_CURRENTUSERS,
  payload: user,
});
